import { useIsFetching } from '@tanstack/react-query';
import {
  useActiveProjectCohortId,
  useActiveProjectId,
} from '../../../../../hooks';

export const useIsFetchingMedicalResults = (patientId: string) => {
  const projectId = useActiveProjectId();
  const cohortId = useActiveProjectCohortId();

  const medicalResultQueriesFetching = useIsFetching({
    queryKey: [
      'medical-results',
      'v3',
      patientId,
      'results',
      {
        projectId,
        cohortId,
      },
    ],
    fetchStatus: 'fetching',
    predicate: query => {
      // Exclude memberUpload and unmappedLabs source queries from blocking the UI
      // Allow other sections to display while wearables/uncategorized data is loading
      const queryKey = query.queryKey;
      const source = queryKey[queryKey.length - 1];
      return source !== 'memberUpload' && source !== 'unmappedLabs';
    },
  });

  return medicalResultQueriesFetching > 0;
};
